import { defineMessages } from 'react-intl';

export default defineMessages({
    /**
     * Messages used in the *.metadata.json5
     */
    noPoliciesFound: {
        id: 'fnol.producer.common.policy-select-producer.No policies were found that match the search criteria.',
        defaultMessage: 'No policies were found that match the search criteria.'
    },
    policyNumberTooltip: {
        id: 'fnol.common.views.policy-select-policyholder.Policy Number Tooltip',
        defaultMessage: 'Policy format required XX12345678'
    },
    policyInfoLabel: {
        id: 'fnol.producer.common.policy-select-producer.If any person(s) involved in this incident has been severely injured, please contact our claims handling centre to process this claim.',
        defaultMessage: 'If any person(s) involved in this incident has been severely injured, please contact our claims handling centre to process this claim.'
    },
    dateOfLoss: {
        id: 'fnol.producer.common.policy-select-producer.Date of loss?',
        defaultMessage: 'Date of loss?'
    },
    whenDidLossOccur: {
        id: 'fnol.producer.common.policy-select-producer.When did loss occur?',
        defaultMessage: 'When did loss occur?'
    },
    selectAPolicy: {
        id: 'fnol.producer.common.policy-select-producer.Against which policy?',
        defaultMessage: 'Against which policy?'
    },
    policyNumber: {
        id: 'fnol.producer.common.policy-select-producer.Policy Number',
        defaultMessage: 'Policy Number'
    },
    policyNumberPlaceholder: {
        id: 'fnol.producer.common.policy-select-producer.Start Typing',
        defaultMessage: 'Start Typing'
    },
    search: {
        id: 'fnol.producer.common.policy-select-producer.Search',
        defaultMessage: 'Search'
    },
    dontHaveYourPolicyNumber: {
        id: 'fnol.producer.common.policy-select-producer.Dont have your policy number?',
        defaultMessage: 'Don\'t have your policy number?'
    },
    noPoliciesFoundThatMatchTheSearchCriteria: {
        id: 'fnol.producer.common.policy-select-producer.No policies were found that match the search criteria',
        defaultMessage: 'No policies were found that match the search criteria'
    },
    /**
     * Messages shown on the Modal when a user triggers a policy change
     */
    changePolicyModalTitle: {
        id: 'fnol.producer.common.policy-select-producer.Policy change',
        defaultMessage: 'Policy change'
    },
    changePolicyModalMessage: {
        id: 'fnol.producer.common.policy-select-producer.You have selected a new policy for this claim. The data you have entered for this claim will be lost.',
        defaultMessage: 'You have selected a new policy for this claim. The data you have entered for this claim will be lost.'
    },
    changePolicyModalConfirmationButtonText: {
        id: 'fnol.producer.common.policy-select-producer.Change Policy',
        defaultMessage: 'Change Policy'
    },
    changePolicyModalCancelButtonText: {
        id: 'fnol.producer.common.policy-select-producer.Cancel',
        defaultMessage: 'Cancel'
    },
    policySearchErrorTitle: {
        id: 'fnol.producer.common.policy-select-producer.Error',
        defaultMessage: 'Error'
    },
    policySearchErrorText: {
        id: 'fnol.producer.common.policy-select-producer.An error occurred while searching for policies',
        defaultMessage: 'An error occurred while searching for policies.'
    },
    policySearchConfirmButtonText: {
        id: 'fnol.producer.common.policy-select-producer.Ok',
        defaultMessage: 'Ok'
    },
    fnolPolicySearchNextButton: {
        id: 'fnol.common.views.policysearch.next',
        defaultMessage: 'ch-fnol-policy-search-next-button'
    },
});
